import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import Operations from "@/pages/Operations";
import Compliance from "@/pages/Compliance";
import AccessControl from "@/pages/AccessControl";
import AuditLog from "@/pages/AuditLog";
import ContractDocs from "@/pages/ContractDocs";
import Settings from "@/pages/Settings";

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Overview />} />
              <Route path="operations" element={<Operations />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="access" element={<AccessControl />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="contract" element={<ContractDocs />} />
              <Route path="config" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AppProvider>
    </div>
  );
}
